/**
 * Injects a favicon link into the <head> of the document.
 * It will also remove any existing favicon link to ensure only one is present.
 *
 * @param {string} href The URL of the favicon file (e.g., '/images/favicon.ico').
 * @param {string} [type='image/x-icon'] The MIME type of the favicon file.
 */
export const injectFavicon = (href: string, type = "image/x-icon") => {
	// 1. Remove existing favicon links
	const existingLinks = document.head.querySelectorAll('link[rel~="icon"]');

	existingLinks.forEach((link) => {
		link.remove();
	});

	// 2. Create the new link element
	const newLink = document.createElement("link");

	// 3. Set its attributes
	newLink.rel = "icon"; // Standard for favicon
	newLink.type = type; // The MIME type
	newLink.href = href; // The URL to the favicon file

	// 4. Append the new link to the <head>
	document.head.appendChild(newLink);
};
